module.exports = __webpack_public_path__ + "static/media/paras_dhole.9c0e6d3f.png";